import { MapSetup } from '@leverege/recovr-plugins'
import RecovrGenericSetup from '@leverege/recovr-plugins/lib/recovrGeneric/PluginSetup.js'
import { 
  OperatingHoursSetup, 
  AlertRulesSetup 
} from '@leverege/recovr-plugins/lib/recovrGeneric/routes/index.js'
import Pairing from '@leverege/api-ui-pairing'
import RingTagSetup from '@leverege/recovr-plugins/lib/r4k/actions/ringTag/PluginSetup.js'
import Routes from './routes/PluginSetup.js'

export default {
  install( molten ) {
    MapSetup.install( molten )
    Pairing.install( molten )
    Routes.install( molten )
    RecovrGenericSetup.install( molten )
    RingTagSetup.install( molten )
    OperatingHoursSetup.install( molten )
    AlertRulesSetup.install( molten )
  }
}
